export default function initSpecialistsSection() {
    if (typeof $().accordionjs === "undefined") {
        return false;
    }

    $(".specialists .accordion-department").accordionjs({
        closeOther: false,
        slideSpeed: 300,
        beforeOpenSection: handleCms,
        beforeCloseSection: handleCms,
    })
}

function handleCms(section, event) {
    if (event === undefined) return;

    const isCms = $(event.target).parents(".cms-action-panel").length != 0;
    if (isCms) {
        // @note добавил на случай если csm-панель расположена на заголовке элемента
        return false;
    }

    return true;
}